<sdc-bo-dialog>
  <p class="text-center">
    Are you sure you want to <b>{{ actionVerb() }}</b> all
    <b>{{ count() }}</b> selected events?
  </p>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="secondary" (onClick)="onDismiss()">Cancel</sdc-button>
    <sdc-button
      [variant]="action() === 'delete' ? 'destructive' : 'primary'"
      (onClick)="onConfirm()">
      {{ actionLabel() }}
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
